module.exports = __webpack_public_path__ + "assets/img/yntwo.4a8d0e9b.png";